import React from "react";
import "../styles/pages.css";
import { Link } from "react-router-dom";
import mainBgImage from "../assets/main.jpg";

function Home() {
  const handleProjectClick = (url) => {
    window.open(url, "_blank");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="home-page">
      <div className="hero-section">
        <div
          className="hero-bg"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `url(${mainBgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
          }}
        ></div>
        <div className="hero-content">
          <div className="logo-container">
            <img
              src="/images/picktechlogo.png"
              alt="PICKTECH Logo"
              className="hero-logo"
              width="120"
              height="120"
            />
          </div>
          <h1 className="hero-title">PICKTECH: Innovative Web Solutions</h1>
          <p className="hero-subtitle">
            Providing cutting-edge digital experiences with WebCraft Pro
            technology.
          </p>
          <div className="hero-buttons">
            <Link to="/webcraft" className="btn btn-primary btn-lg">
              Explore Our Work
            </Link>
            <Link to="/contact" className="btn btn-secondary btn-lg">
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <div className="services-section">
        <div className="container">
          <div className="section-title">
            <h2>Services</h2>
            <div className="title-underline"></div>
          </div>
          <div className="services-grid">
            <Link
              to="/webcraft"
              className="service-card active-service"
              aria-label="WebCraft Pro Service"
            >
              <div className="service-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3>WebCraft Pro</h3>
              <p>
                A complete web solution providing modern responsive websites
                with custom design, SEO optimization, and admin panels.
              </p>
              <div className="active-badge">Active</div>
            </Link>

            <a
              href="https://waitingq.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="service-card active-service"
              aria-label="WaitingQ Service"
            >
              <div className="service-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h3>WaitingQ</h3>
              <p>
                A digital queue management system for restaurants, hospitals,
                and beauty salons. Minimizes waiting times and improves customer
                experience.
              </p>
              <div className="active-badge">Active</div>
            </a>

            <div
              className="service-card coming-soon-card"
              aria-label="StampGo Service Coming Soon"
            >
              <div className="service-icon">
                <i className="fas fa-ticket-alt"></i>
              </div>
              <h3>StampGo</h3>
              <p>
                A digital loyalty card solution for retail stores and cafes.
                Digitizes paper stamp cards to enhance customer relationships.
              </p>
              <div className="coming-soon-badge">Coming Soon</div>
            </div>
          </div>
        </div>
      </div>

      <div className="featured-projects">
        <div className="container">
          <div className="section-title">
            <h2>Projects</h2>
            <div className="title-underline"></div>
          </div>
          <div className="portfolio-grid">
            <div
              className="portfolio-card premium-card clickable-project"
              onClick={() => handleProjectClick("https://orano1.au")}
              aria-label="Visit Ora No.1 Website"
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/ora.png"
                  alt="Ora No.1"
                  className="portfolio-img"
                  loading="lazy"
                  width="400"
                  height="225"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary btn-lg">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>Ora No.1</h3>
                <p>
                  Lidcombe based hair salon with a focus on providing premium
                  hair services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card premium-card clickable-project"
              onClick={() =>
                handleProjectClick("https://mykoreanteacher.com.au")
              }
              aria-label="Visit My Korean Teacher Website"
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/mykoreanteacher.jpg"
                  alt="My Korean Teacher"
                  className="portfolio-img"
                  loading="lazy"
                  width="400"
                  height="225"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary btn-lg">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>My Korean Teacher</h3>
                <p>
                  Lidcombe based Korean language education services with a focus
                  on providing premium Korean language education services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card premium-card clickable-project"
              onClick={() => handleProjectClick("https://withu.au/")}
              aria-label="Visit With U Beauty Website"
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/withu.jpg"
                  alt="With U Beauty"
                  className="portfolio-img"
                  loading="lazy"
                  width="400"
                  height="225"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary btn-lg">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>With U Beauty</h3>
                <p>
                  Strathfield based beauty salon with a focus on providing
                  premium beauty services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "3rem" }}>
            <Link to="/webcraft" className="btn btn-primary btn-lg btn-icon">
              View All Services
              <span className="btn-icon-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="contact-section">
        <div className="container">
          <div className="section-title">
            <h2>Contact Us</h2>
            <div className="title-underline"></div>
          </div>

          <div className="contact-grid">
            <div className="contact-info">
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-info-content">
                  <h3>Location</h3>
                  <p>22 Church Street, Lidcombe NSW 2141</p>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="contact-info-content">
                  <h3>Phone</h3>
                  <p>
                    <a href="tel:+61414989606">+61 414 989 606</a>
                  </p>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-info-content">
                  <h3>Email</h3>
                  <p>
                    <a href="mailto:jacob.yu.webdev@gmail.com">
                      jacob.yu.webdev@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              <div className="whatsapp-btn">
                <a
                  href="https://chat.whatsapp.com/KP8nHB9nnqWJ71LyW8DgiX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-whatsapp"
                >
                  <i className="fab fa-whatsapp"></i> Contact via WhatsApp
                </a>
              </div>
            </div>

            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.2734955673404!2d151.04225287649068!3d-33.835101073236174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12bbe85c678a61%3A0x6b73f626bd3e2db2!2s22%20Church%20St%2C%20Lidcombe%20NSW%202141!5e0!3m2!1sen!2sau!4v1713754863901!5m2!1sen!2sau"
                width="100%"
                height="450"
                style={{
                  border: 0,
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="PICKTECH Office Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Floating button to scroll to top on mobile */}
      <div
        className="floating-action-btn"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <i className="fas fa-arrow-up"></i>
      </div>
    </div>
  );
}

export default Home;
